/**
 * Shown when a non-admin opens /api-docs (sidebar hides the link, but URL can be typed).
 */

import { useApi, configApiRef } from '@backstage/core-plugin-api';
import { AccessDeniedPage } from '../AccessDeniedPage';

export function ApiDocsAccessDeniedPage(): JSX.Element {
  const orgName =
    useApi(configApiRef).getOptionalString('organization.name') ?? 'Backstage';

  return (
    <AccessDeniedPage
      title={orgName}
      description={
        <>
          The API Explorer is restricted to platform administrators. If you need
          access, please contact your <strong>Backstage / platform administrator</strong>{' '}
          and ask them to grant you access.
        </>
      }
    />
  );
}
